import {
	Component,
	ViewEncapsulation,
	OnInit,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { ApiService } from "../../../lib/api.service";
import { LogService } from "../../../lib/log.service";
import { ModalService } from "../../../lib/modal.service";
import { AnalyticEvent } from "app/lib/analytic-event";

@Component({
    selector: "app-access-code",
    templateUrl: "./access-code.component.html",
    styleUrls: ["./access-code.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AccessCodeComponent implements OnInit {
	accesscode: string;
	orgId: number;
	errors: string = '';
	submitButtonPressed: boolean = false;

	constructor(
		private api: ApiService,
		private logService: LogService,
		private modalService: ModalService,
		private route: ActivatedRoute,
		private router: Router,
		private location: Location
	) {
		this.orgId = +this.route.snapshot.paramMap.get('id');
	}

	ngOnInit() {}

	doSave() {
		this.submitButtonPressed = true;
		this.errors = '';

		if (!this.accesscode) {
			this.errors = "Please type in an access code.";
			return;
		}

		this.api
			.post("admin/accesscodecreate", {
				Code: this.accesscode,
				OrgID: this.orgId,
			})
			.subscribe(
				(data: any) => {
					this.modalService.showAlert(
						"Success",
						"Access code has been created"
					);
					this.logService.event(
						AnalyticEvent.event.accessCodeCreated
					);
					this.router.navigate(['/admin/organization', this.orgId]);
				},
				(error: any) => {
					this.logService.debug(error);
					this.modalService.showAlert("Error", error.message);
				}
			);
	}

	onClose() {
		this.location.back();
	}
}
